import { isEqual } from "lodash";

export const actions = {
    START_CREATE_EXECUTION: "START_CREATE_EXECUTION",
    CREATE_EXECUTION_SUCCESSFUL: "CREATE_EXECUTION_SUCCESSFUL",
    CREATE_EXECUTION_FAILED: "CREATE_EXECUTION_FAILED",

    START_UPDATE_EXECUTION: "START_UPDATE_EXECUTION",
    UPDATE_EXECUTION_SUCCESSFUL: "UPDATE_EXECUTION_SUCCESSFUL",
    UPDATE_EXECUTION_FAILED: "UPDATE_EXECUTION_FAILED",

    START_EXECUTION_FETCHING: "START_EXECUTION_FETCHING",
    STORE_EXECUTION_DATA: "STORE_EXECUTION_DATA",
    STORE_EXECUTIONS_DATA: "STORE_EXECUTIONS_DATA",
    CLEAR_EXECUTIONS_DATA: "CLEAR_EXECUTIOMS_DATA",

    START_CREATE_EXECUTION_OPERATION: "START_CREATE_EXECUTION_OPERATION",
    CREATE_EXECUTION_OPERATION_SUCCESSFUL: "CREATE_EXECUTION_OPERATION_SUCCESSFUL",
    CREATE_EXECUTION_OPERATION_FAILED: "CREATE_EXECUTION_OPERATION_FAILED",

    START_EXECUTIONS_OPERATION: "START_EXECUTIONS_OPERATION",
    EXECUTIONS_OPERATION_SUCCESSFUL: "EXECUTIONS_OPERATION_SUCCESSFUL",
    EXECUTIONS_OPERATION_FAILED: "EXECUTIONS_OPERATION_FAILED",
};

export const initialState = {
    listingFetching: false,
    listingResponse: {},
    singleFetching: [],
};

export default (state = initialState, { type, response, iri }) => {
    switch (type) {
        case actions.FETCH_EXECUTION_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.FETCH_EXECUTION_FAILED: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.STORE_EXECUTION_DATA: {
            return Object.assign({}, state, {
                [iri]: response,
            });
        }
        case actions.START_EXECUTION_FETCHING: {
            return {
                ...state,
                listingFetching: true,
            };
        }
        case actions.STORE_EXECUTIONS_DATA: {
            const nextList = response?.execution_list;
            // Websocket pushes arrive on every execution change and often carry a
            // payload identical to the current state. Bail out with the same state
            // reference so the selector value is unchanged and the (heavy) executions
            // table does not re-render every cell for a no-op push.
            if (!state.listingFetching && isEqual(state.executionsList, nextList)) {
                return state;
            }
            return {
                ...state,
                executionsList: nextList,
                listingFetching: false,
            };
        }
        case actions.CLEAR_EXECUTIONS_DATA: {
            const listingStateKeys = new Set([
                "listingFetching",
                "listingResponse",
                "singleFetching",
                "executionsList",
            ]);
            const preservedEntries = Object.fromEntries(
                Object.entries(state).filter(([key]) => !listingStateKeys.has(key))
            );
            return {
                ...preservedEntries,
                listingFetching: true,
                listingResponse: {},
                singleFetching: state.singleFetching,
            };
        }

        default:
            return state;
    }
};
